import React from 'react';
import { useTranslation } from 'react-i18next';
import { LANGS } from '../i18n';

const LanguageSwitcher = ({ className = '' }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className={`lang ${className}`} role="group" aria-label={t('nav.language')}>
      {LANGS.map((lng) => (
        <button
          key={lng}
          type="button"
          className={`lang__btn ${i18n.language === lng ? 'is-active' : ''}`}
          aria-pressed={i18n.language === lng}
          onClick={() => i18n.changeLanguage(lng)}
        >
          {lng.toUpperCase()}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
